import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

/** Matches distillhq.com/golfos marketing (Tailwind: sans + font-serif for OS, gold #c5a059) */
const MARKETING_GOLD = '#c5a059';
const MARKETING_FG = '#f0ece4';

type GolfOSMarkProps = {
  /** Approximate cap height of the wordmark; scales both parts like the marketing nav */
  height?: number;
  /** "light" = dark backgrounds (hero); "dark" = light surfaces (sidebar, login card) */
  variant?: 'dark' | 'light';
  sx?: SxProps<Theme>;
};

/**
 * Wordmark aligned with the public GolfOS page: Inter bold “Golf”, italic Playfair “OS” in gold.
 */
export const GolfOSMark: React.FC<GolfOSMarkProps> = ({
  height = 36,
  variant = 'dark',
  sx = {},
}) => {
  const golfColor = variant === 'dark' ? '#1A3F1B' : MARKETING_FG;
  // Same ratio as marketing nav (text-2xl : text-3xl ≈ 24px : 30px at ~40px row)
  const golfPx = height * 0.6;
  const osPx = height * 0.75;

  return (
    <Box
      role="img"
      aria-label="GolfOS"
      sx={{
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: '0.12em',
        lineHeight: 1,
        WebkitFontSmoothing: 'antialiased',
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
          fontWeight: 700,
          fontSize: `${golfPx}px`,
          letterSpacing: '-0.03em',
          color: golfColor,
        }}
      >
        Golf
      </Box>
      <Box
        component="span"
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontStyle: 'italic',
          fontWeight: 600,
          fontSize: `${osPx}px`,
          color: MARKETING_GOLD,
          position: 'relative',
          top: '0.02em',
        }}
      >
        OS
      </Box>
    </Box>
  );
};
